import { apiRequest } from './apiClient';

export async function getStudentExams() {
  const response = await apiRequest('/student/exams');

  return response.data || [];
}

export async function getStudentExamById(examId) {
  const response = await apiRequest(`/student/exams/${examId}`);

  return response.data || null;
}

export async function startStudentExam(examId) {
  const response = await apiRequest(`/student/exams/${examId}/start`, {
    method: 'POST',
  });

  return response.data || null;
}

export async function submitStudentExam(examId, answers) {
  const response = await apiRequest(`/student/exams/${examId}/submit`, {
    method: 'POST',
    body: { answers },
  });

  return response.data || null;
}
